import { PayoutApiClient } from '@fourthwall/services/dist/PayoutApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeletePayoutConnectionMutation = createMutationHook(
  PayoutApiClient.deletePayoutConnection,
  {
    mutationKey: ['deletePayoutConnection'],
  },
)
